var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tch0ubcvsa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360 0v640H0V0h360z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8katow4deb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.88 13.6c3.672 0 10.88 1.768 10.88 5.44v2.72H0v-2.72c0-3.672 7.208-5.44 10.88-5.44zm0-13.6c2.992 0 5.44 2.448 5.44 5.44 0 2.992-2.448 5.44-5.44 5.44-2.992 0-5.44-2.448-5.44-5.44C5.44 2.448 7.888 0 10.88 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "los1s2ctbc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 0v34H0V0h34z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tch0ubcvsa)",
    transform: "translate(-306 -14)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8katow4deb)",
    transform: "translate(311.12 19.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.76v21.76H0V0z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#los1s2ctbc)",
    transform: "translate(-6.8 -6.8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.8 6.8h21.76v21.76H6.8V6.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccount);
export default __webpack_public_path__ + "static/media/icon-account.7f365fcc1a2aa90c374c707a6e0966ef.svg";
export { ForwardRef as ReactComponent };